export function uid(prefix = ''): string {
  const rand = Math.random().toString(36).slice(2, 10);
  const time = Date.now().toString(36);
  return `${prefix}${prefix ? '_' : ''}${time}${rand}`;
}

export function generateBarcode(): string {
  const base = Math.floor(1_000_000_000_000 + Math.random() * 8_999_999_999_999);
  return base.toString();
}

export function generateSKU(): string {
  const ts = Date.now().toString(36).toUpperCase();
  const rnd = Math.random().toString(36).slice(2, 6).toUpperCase();
  return `SKU-${ts}-${rnd}`;
}

export function generateInvoiceNumber(prefix = 'INV'): string {
  const ts = new Date();
  const ymd = `${ts.getFullYear()}${String(ts.getMonth() + 1).padStart(2, '0')}${String(ts.getDate()).padStart(2, '0')}`;
  const rnd = Math.floor(Math.random() * 9000 + 1000);
  return `${prefix}-${ymd}-${rnd}`;
}

export function generateReference(prefix = 'EXP'): string {
  return generateInvoiceNumber(prefix);
}
